<template>
  <div class="scrollbar-container">
    <div class="box-left">
      <span class="el-icon-arrow-left" @click="handleScroll(-250)"></span>
    </div>

    <el-scrollbar
      ref="scrollContainer"
      :vertical="false"
      class="scroll-container"
      @wheel.native.prevent="handleScroll"
    >
      <slot />
    </el-scrollbar>
    <div class="box-right">
      <span class="el-icon-arrow-right" @click="handleScroll(250)"></span>
      <span class="el-icon-close" @click="closeAllTags()"></span>
    </div>
  </div>
</template>

<script>
const tagAndTagSpacing = 4;

export default {
  name: "ScrollPane",
  data() {
    return {
      left: 0,
    };
  },
  methods: {
    handleScroll(left) {
      // const eventDelta = e.wheelDelta || -e.deltaY * 40;
      const $scrollWrapper = this.$refs.scrollContainer.$refs.wrap;
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + left;
    },
    moveToTarget(currentTag) {
      const $container = this.$refs.scrollContainer.$el;
      const $containerWidth = $container.offsetWidth;
      const $scrollWrapper = this.$refs.scrollContainer.$refs.wrap;
      const tagList = this.$parent.$refs.tag;

      let firstTag = null;
      let lastTag = null;

      if (tagList.length > 0) {
        firstTag = tagList[0];
        lastTag = tagList[tagList.length - 1];
      }

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0;
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft =
          $scrollWrapper.scrollWidth - $containerWidth;
      } else {
        const currentIndex = tagList.findIndex((item) => item === currentTag);
        const prevTag = tagList[currentIndex - 1];
        const nextTag = tagList[currentIndex + 1];
        const afterNextTagOffsetLeft =
          nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing;
        const beforePrevTagOffsetLeft =
          prevTag.$el.offsetLeft - tagAndTagSpacing;

        if (
          afterNextTagOffsetLeft >
          $scrollWrapper.scrollLeft + $containerWidth
        ) {
          $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth;
        } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
          $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft;
        }
      }
    },
    closeAllTags() {
      this.$emit("close");
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.scrollbar-container {
  position: relative;
  padding: 0 50px 0 24px;
  height: 34px;

  .box-right,
  .box-left {
    position: absolute;
  }
  .box-left {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translate(0, -50%);
  }
  .box-right {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .scroll-container {
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    width: 100%;
    box-shadow: inset 0 0 3px 2px hsla(0, 0%, 39%, 0.1);
  }
}
</style>
